module.exports = __webpack_public_path__ + "img/newBg.16cd8d0e.png";